module.exports = __webpack_public_path__ + "img/contacto_16-9_2880.decc4133.jpg";